import { IPatientInternalNote } from "../models/IPatientInternalNote";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class PatientInternalNoteApi extends ApiClient {

    getPatientInternalNotes(patientId: number, success: (data: IPatientInternalNote[]) => void, error?: (message: string) => void) {
        this.get<IPatientInternalNote[]>(`${Utils.LIB_API_BASE_URL}/patientInternalNotes/patient/${patientId}`, success, error);
    }

    getPatientInternalNote(patientNoteId: number, success: (data: IPatientInternalNote) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IPatientInternalNote>(`${Utils.LIB_API_BASE_URL}/patientInternalNotes/${patientNoteId}`, success, error, final);
    }

    savePatientInternalNote(data: IPatientInternalNote, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/patientInternalNotes`, data, success, error, final);
    }

    deletePatientInternalNote(patientNoteId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/patientInternalNotes/${patientNoteId}`, success, error, final);
    }
}